import type { PropertyFilters } from '~/core/entities/property/filters';
import type { VariantProps } from 'class-variance-authority';

import { cva } from 'class-variance-authority';

export { default as OrdenationSelect } from './Select.vue';

export interface OrdenationDropdownProps {
	labelVariant?: OrdenationSelectLabelVariant['variant'];
}

export interface OrdenationDropdownOption {
	label: string;
	value?:
		| 'images_count_asc'
		| 'images_count_desc'
		| 'asking_price_asc'
		| 'asking_price_desc'
		| 'area_price_asc'
		| 'area_price_desc'
		| 'area_asc'
		| 'area_desc'
		| 'publication_date_desc'
		| 'pilar_exclusivities'
		| 'highlights'
		| 'most_recent'
		| 'older'
		| 'wishlist_recent'
		| 'wishlist_oldest'
		| 'default_ordenation';
	sortBy: PropertyFilters['sortBy'];
	orderBy: PropertyFilters['orderBy'];
}

export const ordenationSelectLabelVariant = cva('', {
	variants: {
		variant: {
			default: 'hidden sm:inline lg:hidden xl:inline',
			hidden: 'hidden'
		}
	},
	defaultVariants: {
		variant: 'default'
	}
});

export type OrdenationSelectLabelVariant = VariantProps<
	typeof ordenationSelectLabelVariant
>;
